import { customAsyncThunk } from 'utils/createThunk'
import { settings } from '../../../services/endpoints'

const createRoles = customAsyncThunk('settings/create_roles', 'post', settings.roles)
const getRoles = customAsyncThunk('settings/getRoles', 'get', settings.roles)

export {
    createRoles,
    getRoles,
}